import type { CmdbObjectAttribute } from '../../../../../services/cmdb-objects/types';

export const getVisibleAttributes = (
	attributes: CmdbObjectAttribute[],
	attributesToDisplay: string[],
): CmdbObjectAttribute[] => {
	const notUndefined = (attr: CmdbObjectAttribute | undefined): attr is CmdbObjectAttribute => {
		return Boolean(attr);
	};
	return attributesToDisplay
		.map((attrName) =>
			attrName === 'Label'
				? attributes.find((attr) => attr.objectTypeAttribute.label)
				: attributes.find((attr) => attr.objectTypeAttribute.name === attrName),
		)
		.filter(notUndefined)
		.filter(
			(attribute) =>
				attribute.objectAttributeValues.length > 0 &&
				attribute.objectAttributeValues.every((value) => value && value.displayValue),
		);
};

export const createAttributeString = (attributes: CmdbObjectAttribute[]): string => {
	return attributes
		.map((attribute) =>
			attribute.objectAttributeValues.map((value) => value.displayValue).join(', '),
		)
		.join(' | ');
};
